<template>
<div>
    <div class="row justify-content-center">
       <div class="col-10">
                <div class="text-left section-title" style="padding: 5px;">
                <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>Recurring Expenses</span>
                </div>
            </div>
     
    </div>

    <div class="row" style="padding-left: 15px; padding-right: 15px;">
      <div class="col-6 offset-3">
          <div class="container form-background">
              <div class="row">
                  <div class=" col-12 text-left form-title">
                      <span class="row-table-font-margins">{{ formTitle }} for building {{ buildingName }}</span>
                  </div>
              </div>
              <div class="row">
                  <div class="col-md-6">
                      <label>Expense type:</label>
                      <select class="form-control" v-model="expenseTypeId">
                          <option v-for="expenseType in expenseTypes"
                                  v-bind:key="expenseType"
                                  :value="expenseType.id">
                              {{ expenseType.name }}
                          </option>
                      </select>
                      <div v-if="submitted && !expenseTypeId"
                           class="invalid-feedback d-block">
                          ExpenseType is required
                      </div>
                  </div>
                  <div class="col-md-6">
                      <label>Supplier:</label>
                      <select id="registered-owner"
                              class="form-control"
                              :disabled="expenseTypeId == 0"
                              v-model="supplierId">
                          <option v-for="supplier in serviceProviderFilter(expenseTypeId)"
                                  v-bind:key="supplier"
                                  :value="supplier.id">
                              {{ supplier.name }}
                          </option>
                      </select>
                      <div v-if="submitted && !supplierId" class="invalid-feedback d-block">
                          Supplier is required
                      </div>
                  </div>
              </div>

              <div class="row">
                  <div class="col-md-6">
                      <label>From:</label>
                      <select name="startingMonth"
                              v-model="startingMonth"
                              id=""
                              class="form-control">
                          <option v-for="(month, index) in startingMonths"
                                  :key="index"
                                  :value="month.id">
                              {{ month.name }}
                          </option>
                      </select>
                      <div v-if="submitted && !startingMonth"
                           class="invalid-feedback d-block">
                          From month is required
                      </div>
                  </div>
                  <div class="col-md-6">
                      <label>To: *</label>
                      <select name="endingMonth"
                              v-model="endingMonth"
                              id=""
                              class="form-control">
                          <option v-for="(month, index) in endingMonths(startingMonth)"
                                  :key="index"
                                  :value="month.id">
                              {{ month.name }}
                          </option>
                      </select>
                      <div v-if="submitted && !startingMonth"
                           class="invalid-feedback d-block">
                          To month is required
                      </div>
                  </div>
              </div>

              <div class="row">
                  <div class="col-md-6">
                      <label>Amount per period: </label>
                      <input type="text"
                             class="form-control text-left"
                             v-model="amount"
                             number
                             data-type="currency" />
                      <div v-if="submitted && !amount" class="invalid-feedback d-block">
                          Amount is required
                      </div>
                  </div>
                  <div class="col-md-6">
                      <label>Is Additional Expense:</label>
                      <input type="checkbox"
                             name="isAdditionalExpense"
                             v-model="isAdditionalExpense" />
                  </div>
                 

              </div>

              <div v-if="isAdditionalExpense" class="row">
                  <div class="table-responsive col-md-12" style="box-shadow:none;border:0">
                      <div v-if="building.isComplex">
                          <table class="table table-condensed" style="width: 100%;">
                              <thead class="">
                                  <tr>
                                      <th style="

                        width: 20%;
                      "
                                          class="no-border text-center">
                                          No
                                      </th>
                                      <th style="

                        width: 20%;
                      "
                                          class="no-border text-center">
                                          Building
                                      </th>
                                      <th style="

                        width: 20%;
                      "
                                          class="no-border text-center">
                                          Property
                                      </th>
                                      <th style="

                        width: 20%;
                      "
                                          class="no-border text-center">
                                          Square Meters
                                      </th>
                                      <th style="

                        width: 20%;
                      "
                                          class="no-border text-center">
                                          Sq. Meters %
                                      </th>
                                      <th style="

                        width: 20%;
                      "
                                          class="no-border text-center col-md-3">
                                          Amount
                                      </th>
                                      <th class="no-border col-md-2">
                                          <button :disabled="amount <= 0"
                                                  class="btn btn-primary"
                                                  @click="distribute()"
                                                  onclick="return false;">
                                              Distribute Amount
                                          </button>
                                      </th>
                                  </tr>
                              </thead>
                              <tbody style="border: 1px solid rgba(221, 221, 221, 1);">
                                  <tr v-for="(property, key) in properties"
                                      :key="property.property.id">
                                      <td class="text-center">
                                          {{ ++key }}
                                      </td>
                                      <td class="text-center">
                                          {{ property.building.name }}
                                      </td>
                                      <td class="text-center">
                                          {{ property.property.floor }} -
                                          {{ property.property.number }}
                                      </td>
                                      <td class="text-center">
                                          {{ property.property.square_meters }}
                                      </td>
                                      <td class="text-center">
                                          {{
                        (
                          (property.property.square_meters * 100) /
                          totalSquareMeters
                        ).toFixed(2)
                                          }}%
                                      </td>
                                      <td>
                                          <input type="text"
                                                 number
                                                 class="form-control text-right"
                                                 v-model="property.amount"
                                                 data-type="currency" />
                                      </td>
                                      <td></td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                      <div v-else>
                          <table class="table table-condensed" style="100%">
                              <thead class="">
                                  <tr>
                                      <th style="

                        width: 10.5%;
                      "
                                          class="no-border text-center">
                                          No
                                      </th>
                                      <th style="

                        width: 15.5%;
                      "
                                          class="no-border text-center">
                                          Property
                                      </th>
                                      <th style="

                        width: 15.5%;
                      "
                                          class="no-border text-center">
                                          Square Meters
                                      </th>
                                      <th style="

                        width: 15.5%;
                      "
                                          class="no-border text-center">
                                          Sq. Meters %
                                      </th>
                                      <th style="

                        width: 15.5%;
                      "
                                          class="no-border text-center">
                                          Amount
                                      </th>
                                      <th class="no-border" style="width: 15%;">
                                          <button style="width: 100%;"
                                                  :disabled="amount <= 0"
                                                  class="btn btn-primary"
                                                  @click="distributeToSelected()"
                                                  onclick="return false;">
                                              Distribute To Selected
                                          </button>
                                      </th>
                                      <th class="no-border" style="width: 15%;">
                                          <button style="width: 100%;"
                                                  :disabled="amount <= 0"
                                                  class="btn btn-primary"
                                                  @click="distribute()"
                                                  onclick="return false;">
                                              Distribute Amount
                                          </button>
                                      </th>
                                  </tr>
                              </thead>
                              <tbody style="border: 1px solid rgba(221, 221, 221, 1);">
                                  <tr v-for="(property, key) in properties" :key="property.id">
                                      <td class="text-center">
                                          {{ ++key }}
                                      </td>

                                      <td class="text-center">
                                          {{ property.propertyName }}
                                      </td>
                                      <td class="text-center">
                                          {{ property.squareMeters }}
                                      </td>
                                      <td class="text-center">
                                          {{
                        (
                          (property.squareMeters * 100) /
                          totalSquareMeters
                        ).toFixed(2)
                                          }}%
                                      </td>
                                      <td>
                                          <input type="text"
                                                 number
                                                 class="form-control text-right"
                                                 v-model="property.amount"
                                                 data-type="currency" />
                                      </td>
                                      <td class="text-center">
                                          <input type="checkbox" v-model="property.isSelected" />
                                      </td>
                                      <td></td>
                                  </tr>
                                  <tr>
                                      <td class="text-center"></td>

                                      <td class="text-center"></td>
                                      <td class="text-center"></td>
                                      <td class="text-center">
                                          <strong>Total</strong>
                                      </td>
                                      <td class="text-right">
                                          <strong>{{ TotalAmount }} </strong>
                                      </td>
                                      <td class="text-center"></td>
                                      <td></td>
                                  </tr>
                              </tbody>
                          </table>
                          <div v-show="formIsNotValid & submitted"
                               class="invalid-feedback"
                               style="font-width: bold; font-size: 16px; text-align: center;">
                              Form invalid, recheck the input
                          </div>
                      </div>
                  </div>
              </div>



              <!-- <div v-if="!isPartOfComplex"
      class="form-group"
      style="padding-left: 15px; padding-right: 15px;"
    >
      <strong>Is Complex: </strong>
      <input
        type="checkbox"
        v-model="building.isComplex"
        class="form-check-input"
      />
    </div> -->



              <input type="hidden" name="user_id" value="user_id" />
              <section id="complexes" style="display: none;"></section>
          </div>
         <div class="text-right">
          <button  type="submit"
            @click.prevent="saveRecurringExpense()" class="btn btn-submit" style="margin: 15px;">
            Submit
          </button>
          <button @click="cancel()" class="btn btn-cancel">Cancel</button>
        </div>
      </div>
     
    </div>
  </div>


</template>

<script>
import { mapState } from "vuex";
import { redirectToBuildingList } from "@/_helpers/list-redirect";
export default {
  data: function () {
    return {
      startingMonth: 1,
      endingMonth: 2,
      expenses: [],
      suppliers: [],
      expenseTypes: [],
        amount: 0,
        totalSquareMeters: 0,
        properties:[],
      id: 0,
      expenseTypeId: 0,
      supplierId: 0,
      submitted: false,
      errors: [],
      formTitle: "Add new recurring expense",
        buildingId: 0,
        isAdditionalExpense:false,
     // buildingName: "",
      months: [],
        submitOrUpdate: "Submit",

    };
  },
  watch: {
    startingMonth: function (val) {
      this.startingMonth = val;
      if (this.startingMonth >= this.endingMonth)
        this.endingMonth = this.startingMonth + 1;
    },
  },
  mounted() {
    if (redirectToBuildingList(this, "recurringexpenses")) return;
    //this.buildingName = this.$route.params.buildingName;

    if (this.$route.params.id) {
      this.formTitle = "Update recurring expense";
      this.submitOrUpdate = "Update";
      this.id = this.$route.params.id;
      this.buildingId = this.$route.params.buildingId;
      this.getMonths();
      this.getSuppliers();
      this.getReccuringExpense();
    } else {
      this.buildingId = this.$route.params.buildingId;
      this.getMonths();
      this.getSuppliers();
    }
  },
        methods: {
            distributeToSelected: function () {
                try {
                    var amount = this.amount;
                    var square_meter_percent = 0;
                    var totalSqm = 0;
                    for (var i = 0; i < this.properties.length; i++) {
                        if (this.properties[i].isSelected)
                            totalSqm += this.properties[i].squareMeters;
                    }

                    for (i = 0; i < this.properties.length; i++) {
                        if (this.properties[i].isSelected) {
                            square_meter_percent = 0;
                            square_meter_percent =
                                (this.properties[i].squareMeters * 100) / totalSqm;
                            this.properties[i].amount = parseFloat(
                                (amount * square_meter_percent) / 100
                            ).toFixed(2);
                        } else this.properties[i].amount = 0;
                    }
                } catch (e) {
                    alert(e);
                }
            },

            distribute: function () {
                try {
                    var amount = this.amount;
                    for (var i = 0; i < this.properties.length; i++) {
                        var square_meter_percent = 0;
                        square_meter_percent =
                            (this.properties[i].squareMeters * 100) / this.totalSquareMeters;
                        this.properties[i].amount = parseFloat(
                            (amount * square_meter_percent) / 100
                        ).toFixed(2);
                    }
                } catch (e) {
                    alert(e);
                }
            },
            checkForm: function () {
                var canSubmit =
                    this.amount &&
                    this.startingMonth &&
                    this.endingMonth &&
                    this.expenseTypeId;
                this.errors = [];

                // if (!this.expense.expenseTypeId) {
                // 		this.errors.push('Please select expense type.');
                // 	}

                // if (!this.expense.supplierId) {
                // 		this.errors.push('Please select creditor.');
                // 	}

                // 	if (this.expense.amount <= 0) {
                // 		this.errors.push('Please enter expense amount.');
                // 	}

                // 	if (!this.expense.dueDate) {
                // 		this.errors.push('Please enter expense date.');
                // 	}

                var paymentAmount = parseFloat(this.amount).toFixed(2);

                var allocatedAmount = 0;
                for (var i = 0; i < this.properties.length; i++) {
                    allocatedAmount += parseFloat(this.properties[i].amount == undefined ? 0 : this.properties[i].amount);
                }

                if (paymentAmount != allocatedAmount.toFixed(2)) {
                    if (canSubmit) {
                        var sum = 0;
                        for (var j = 0; j < this.properties.length; j++) {
                            sum += parseFloat(this.properties[j].amount == undefined ? 0 : this.properties[j].amount);
                        }

                        /*	var options = {
                                                          loader: true,
                                                          type: 'hard'
                                                      };*/
                        //var answer =this.showDialog();
                        /*var answer = this.$dialog.confirm("Expense amount is �" + this.expense.amount + " but \n you have distributed �" + sum +".\n Do you want to continue?",options)
                                                          .then(function (dialog) 
                                                          {
                                                              e.preventDefault();
                                                              alert("1");
                                                          })
                                                          .catch(function () {
                                                              this.errors.push('Distributed amount does not match expense amount.');
                                                      alert("2")
                                                          });*/
                        //alert(sum);
                        var answer = confirm(
                            "Expense amount is �" +
                            parseFloat(this.amount).toFixed(2) +
                            " but \n you have distributed �" +
                            sum.toFixed(2) +
                            ".\n Do you want to continue?"
                        );
                        if (answer) {
                            //some code
                        } else {
                            this.errors.push(
                                "Distributed amount does not match expense amount."
                            );
                        }
                    } else {
                        this.errors.push("Distributed amount does not match expense amount.");
                    }
                }

                if (this.errors.length > 0) {
                    alert(this.errors.join("\n"));
                    return false;
                }
                return true;
            },
    cancel() {
      this.$router.push({
        name: "recurringexpenses",
        params: { buildingId: this.buildingId },
      });
    },
    getSuppliers: async function () {
      var request = "/expenses/providers";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then((response) => {
          this.mute = false;
          //this.contacts = data.contacts;

          this.expense = response.data.expenses;
          this.suppliers = response.data.suppliers;
            this.expenseTypes = response.data.expenseTypes;
            this.properties = response.data.properties;
            for (var i = 0; i < this.properties.length; i++)
                this.properties[i].amount = undefined;
            this.totalSquareMeters = response.data.totalSquareMeters;
        });
    },
    serviceProviderFilter: function (expenseType_id) {
      if (!expenseType_id) return null;
      var items = this.suppliers;
      var result = items.filter(function (item) {
        console.log(item);
        return item.serviceTypes.some(
          (x) => x.expenseTypeId === expenseType_id
        );
      });

      return result;
    },
    endingMonths(fromMonth) {
      var endingMonths = this.months.filter(function (value) {
        return value.id > fromMonth;
      });

      return endingMonths;
    },
    getMonths: function () {
      this.mute = true;
      //this.buildingId = 3;
      var request = "/months";
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then((response) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.months = response.data.months;
        });
    },
    getReccuringExpense: function () {
      this.$http.get("/recurringexpenses/" + this.id).then((response) => {
        this.buildingId = response.data.buildingId;
        // this.buildingName = response.data.building.name,
        this.expenseTypeId = response.data.expenseTypeId;
        this.supplierId = response.data.supplierId;
        this.amount = response.data.amount;
        this.startingMonth = response.data.startingMonth;
          this.endingMonth = response.data.endingMonth;
          this.isAdditionalExpense = response.data.isAdditionalExpense;
      });
    },
    saveRecurringExpense: function () {
      var canSubmit =
        this.amount &&
        this.startingMonth &&
        this.endingMonth &&
            this.expenseTypeId;

        if (this.isAdditionalExpense && !this.checkForm()) return;
      if (this.id) {
        this.submitted = true;
        if (canSubmit)
          this.$http
            .put("/recurringexpenses/" + this.id, {
              id: this.id,
              expenseTypeId: this.expenseTypeId,
              amount: this.amount,
              startingMonth: this.startingMonth,
              endingMonth: this.endingMonth,
              buildingId: this.buildingId,
                supplierId: this.supplierId,
                isAdditionalExpense: this.isAdditionalExpense,
                properties: this.properties,
            })
            .then(
              () => {
                this.$router.push({
                  name: "recurringexpenses",
                  params: { buildingId: this.buildingId },
                });
              },
              () => {
                alert("error");
                //  this.infoError = true
                //  this.loader = false
                //   this.password = ''
              }
            );
      } else {
        this.submitted = true;
        if (canSubmit)
          this.$http
            .post("/recurringexpenses", {
              expenseTypeId: this.expenseTypeId,
              amount: this.amount,
              startingMonth: this.startingMonth,
              endingMonth: this.endingMonth,
              buildingId: this.buildingId,
                supplierId: this.supplierId,
                isAdditionalExpense: this.isAdditionalExpense,
                properties: this.properties,
            })
            .then(
              () => {
                this.$router.push({
                  name: "recurringexpenses",
                  params: { buildingId: this.buildingId },
                });
              },
              () => {
                alert("error");
                //  this.infoError = true
                //  this.loader = false
                //   this.password = ''
              }
            );
      }
    },
  },
  computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
    startingMonths() {
      var startingMonths = this.months.filter(function (value) {
        return value.id < 12;
      });

      return startingMonths;
      },
      TotalAmount() {
          var totalAmount = 0;
          for (var i = 0; i < this.properties.length; i++) {
              totalAmount += parseFloat(this.properties[i].amount == undefined ? 0 : this.properties[i].amount);
          }
          return parseFloat(totalAmount).toFixed(2);
      }
  },
  // Our Javascript logic
};
</script>
